import { render, staticRenderFns } from "./leaveRecord.vue?vue&type=template&id=d2867e70&"
import script from "./leaveRecord.vue?vue&type=script&lang=js&"
export * from "./leaveRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports